import { reactive } from 'vue'

export function useGeolocationDialog () {
  const state = reactive({
    isOpen: false,
    negativeButtonText: '',
    positiveButtonText: '',
    title: '',
    georeverseAddress: null,
    createMode: false,
    editMode: false,
    markers: null,
    event: null,
    onConfirm: null
  })

  /**
   * Opens a configurable dialog and initializes its state.
   *
   * @param {Object} options - Configuration options for opening the dialog.
   * @param {string} [options.title=""] - The title to display in the dialog.
   * @param {string} [options.negativeButtonText=""] - The text for the negative action button.
   * @param {string} [options.positiveButtonText=""] - The text for the positive action button.
   * @param {?string} [options.georeverseAddress=null] - The address to display based on reverse geocoding, if available.
   * @param {boolean} [options.createMode=false] - Whether the dialog operates in creation mode.
   * @param {boolean} [options.editMode=false] - Whether the dialog operates in edit mode.
   * @param {?Array} [options.markers=null] - An array of markers to be displayed in the dialog.
   * @param {?Function} [options.onConfirm=null] - Callback function to execute when the positive action is confirmed.
   */
  const open = (options) => {
    const {
      title = '',
      negativeButtonText = '',
      positiveButtonText = '',
      georeverseAddress = null,
      createMode = false,
      editMode = false,
      markers = null,
      onConfirm = null,
      event = null
    } = options || {}

    state.isOpen = true
    state.title = title
    state.negativeButtonText = negativeButtonText
    state.positiveButtonText = positiveButtonText
    state.georeverseAddress = georeverseAddress
    state.createMode = createMode
    state.editMode = editMode
    state.markers = markers
    state.event = event
    state.onConfirm = onConfirm
  }

  /**
   * Closes the modal dialog and resets its state.
   */
  const close = () => {
    state.isOpen = false
    state.title = ''
    state.negativeButtonText = ''
    state.positiveButtonText = ''
    state.georeverseAddress = null
    state.createMode = false
    state.editMode = false
    state.markers = null
    state.event = null
    state.onConfirm = null
  }

  return {
    state,
    open,
    close
  }
}
